// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1akop","list":"styles_list__2lb9P"};